module.exports = __webpack_public_path__ + "img/btn2.0dfab145.png";